export const getAndroidTWAStatus = (): boolean => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('source_app') === 'android_twa';
};
